import { useEffect, useState } from 'react';
import { useMediaQuery, Theme, Box } from '@mui/material';
import { Profile } from './components';
import { useDispatch, useSelector } from 'react-redux';
import { settingsView, showActualSection } from '@/store/actions';
import { authSelector } from '@/store/selectors';
import { UseFirstRender } from '@/hooks';
import { useRouter } from 'next/router';

export const Settings = () => {
  const [step, setStep] = useState(1);
  const router = useRouter()
  const dispatch = useDispatch();
  const { user } = useSelector(authSelector);
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));


  useEffect(() => {
    dispatch(showActualSection('my_profile'));
  }, []);

  UseFirstRender(() => {
    if (user?.token) {
      dispatch(settingsView(user.id));
    }
    else{
      router?.push('/app/register')
    }
  }, [dispatch]);


  return (
    <Box
      display={'flex'}
      paddingBottom={'2rem'}
      width={'100%'}
      margin={'0 auto'}
      height={!isMobile ? '100vh':'100vh'}
      textOverflow={'auto'}
      paddingTop={!isMobile ? '10rem' : '6rem'}
      justifyContent={'flex-start'}
      px={2}
      sx={{
        backgroundImage: !isMobile ? 'url("/images/thread.svg")' : 'none',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
      flexDirection={!isMobile ? 'row' : 'column'}
      alignItems={'flex-start'}
      overflow={!isMobile ? 'auto' : 'auto'}>

    <Profile />
    </Box>
  );
};
